import { Organization } from "@deere/persistent-header";
import React from "react";
import { Socket } from "socket.io-client";
import { User } from "../../types";

export type AppState = {
  selectedOrganization: Organization | undefined;
  socket: Socket | null;
  latency: number;
  user: User;
  // fullMQTT: any;
};

const initialState: AppState = {
  selectedOrganization: undefined,
  socket: null,
  latency: 0,
  user: { userId: "", name: "", role: "", hasPermissions: false },
  // fullMQTT: {}
};

export const AppContext: React.Context<AppState> = React.createContext<AppState>(initialState);
